module.exports = __webpack_public_path__ + "img/senalando-izqpa.894c8af7.png";